import React, {useEffect} from 'react';
import BannerBlog from '../Blog/BannerBlog/index'


export default function Blog(props) {

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(<>
    <BannerBlog/>
    </>)
}